import { useLocale } from "../../redux/general/selectors";
import { getDateText, getShortFormattedDate } from "../../utils/dates";
import enLocale from "date-fns/locale/en-US";
import deLocale from "date-fns/locale/de";

type DateValue = Date | string | null;

type LocalizedDateFormatters = {
  getDateText: (date: DateValue) => string;
  getShortFormattedDate: (date: DateValue) => string;
};

export default function useLocalizedDateFormatters(): LocalizedDateFormatters {
  const isDeLocale = useLocale() === "de_DE";
  const locale = isDeLocale ? deLocale : enLocale;

  return {
    getDateText: (date: DateValue) => getDateText(date, locale),
    getShortFormattedDate: (date: DateValue) =>
      getShortFormattedDate(date, locale),
  };
}
